import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { cashbackConstants, cashbackModels } from '..';

export const useCashbackConfigAll = (props: { onSuccess?: (data?: cashbackModels.ICashbackConfig[]) => void } = {}) => {
  const data = useQuery<cashbackModels.ICashbackConfig[]>({
    queryKey: [cashbackConstants.queryKeys.CASHBACK_CONFIG_ALL],
    queryFn: async () => {
      const res = await $api.get('/v1/cashback/config/all');

      return res.data.data;
    },
    onSuccess: data => {
      if (props?.onSuccess) {
        props?.onSuccess(data);
      }
    }
  });

  const idOfData = (data?.data || [])?.reduce<Record<number, cashbackModels.ICashbackConfig>>((p, c) => {
    if (c?.id) {
      p[c?.id] = c;
    }

    return p;
  }, {});

  return { ...data, idOfData };
};
